import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/login";
import Register from "@/pages/register";
import FrontPage from "@/pages/frontPage";
import Medical from "@/pages/MedicalFront";
import EducateFront from "@/pages/educateFront";
import MedicalStaffManagement from "@/pages/medicalStaffManagement/index.vue";
import EducationStaffManagement from "@/pages/educationStaffManagement/index.vue";
import AdvancedCertification from "@/pages/advancedCertification";
import MedicalInstitution from "@/pages/medicalInstitution";
import MedicalInstitutionInformation from "@/pages/medicalInstitutionInformation";
import EducationalCertificationAdd from "@/pages/educationalCertificationAdd";
import EducationalCertificationTable from "@/pages/educationalCertificationTable";
import EducationalCertificationRevise from "@/pages/educationalCertificationRevise";
import EducationalInstitutionInformation from "@/pages/educationalInstitutionInformation";
import MedicalCertificationModification from "@/pages/medicalCertificationModification";
import EducationViewMedicalHomepage from "@/pages/educationViewMedicalHomepage";
import AllPagesName from "@/pages/allPagesName";
import AuditFailure from "@/pages/popupWindows/auditFailure.vue";
import UserFailure from "@/pages/popupWindows/userFailure.vue";
import ReviewSucceeded from "@/pages/popupWindows/reviewSucceeded.vue";
import UnderReview from "@/pages/popupWindows/underReview.vue";
import EducationAuditFailure from "@/pages/educationStaffManagement/auditFailure.vue";
import UserApplying from "@/pages/educationStaffManagement/applying.vue";
import EducationReviewSucceeded from "@/pages/educationStaffManagement/reviewSucceeded.vue";
import EducationUnderReview from "@/pages/educationStaffManagement/underReview.vue";
import MedicalViewEducationHomepage from "@/pages/medicalViewEducationHomepage";
import EmployeeApplicationFailed from "@/pages/employeeApplicationFailed";
import EducationViewJobInformation from "@/pages/educationViewJobInformation";
import EducationalInformationReply from "@/pages/educationalInformationReply";
import MedicalInformationReply from "@/pages/medicalInformationReply";
import MedicalJobInformationReply from "@/pages/medicalJobInformationReply";
import MedicalInstitutionJobCreation1 from "@/pages/medicalInstitutionJobCreation1";
import MedicalInstitutionJobCreation2 from "@/pages/medicalInstitutionJobCreation2";
import MedicalInstitutionJobCreation3 from "@/pages/medicalInstitutionJobCreation3";
import EducationTalentAdd1 from "@/pages/educationTalentAdd1";
import EducationTalentAdd2 from "@/pages/educationTalentAdd2";
import EducationTalentAdd3 from "@/pages/educationTalentAdd3";
import EducationalInstitutionAddRecruiter from "@/pages/educationalInstitutionAddRecruiter/index.vue";
import MedicalViewAllCandidates from "@/pages/medicalViewAllCandidates/index.vue";
import EducationalViewAllCases from "@/pages/educationalViewAllCases/index.vue";
import MedicalInstitutionCaseRecruitmentList from "@/pages/medicalInstitutionCaseRecruitmentList/index.vue";
import EducationalInstitutionCaseCollectionList from "@/pages/educationalInstitutionCaseCollectionList/index.vue";
import MedicalFavouritesEducationalInstitutionsViewList from "@/pages/medicalFavouritesEducationalInstitutionsViewList/index.vue";
import EducationInstitutionCaseResponderViewing from "@/pages/educationInstitutionCaseResponderViewing/index.vue";
import EducationalInstitutionsTalentApplicationList from "@/pages/educationalInstitutionsTalentApplicationList/index.vue";
import AdministratorInformationManagement from "@/pages/administratorInformationManagement/index.vue";
import AdminStaffManagement from "@/pages/adminStaffManagement/index.vue";
import AdministratorCaseManagement from "@/pages/administratorCaseManagement/index.vue";
import AdministratorApplicationManagement from "@/pages/administratorApplicationManagement/index.vue";
import AdministratorApplicationManagementOnlyCase from "@/pages/administratorApplicationManagementOnlyCase/index.vue";
import AdministratorApplicationManagementOnlyEducation from "@/pages/administratorApplicationManagementOnlyEducation/index.vue";
import AdminTalentManagement from "@/pages/adminTalentManagement/index.vue";
import AdministratorViewEducationalList from "@/pages/administratorViewEducationalList/index.vue";
import MedicalInstitutionTalentInformationViewPublic from "@/pages/medicalInstitutionTalentInformationViewPublic/index.vue";
import MedicalInstitutionCaseManagementDetails from "@/pages/medicalInstitutionCaseManagementDetails/index.vue";
import EducationalInstitutionTalentRevisionProgress3 from "@/pages/educationalInstitutionTalentRevisionProgress3/index.vue";
import EducationalInstitutionCollectionMedicalInstitutionList from "@/pages/educationalInstitutionCollectionMedicalInstitutionList/index.vue";
import EducationalInstitutionTalentListView from "@/pages/educationalInstitutionTalentListView/index.vue";
//import MedicalInstitutionsViewCaseManagement from '@/pages/medicalInstitutionsViewCaseManagement/index.vue'
import AdministratorMedicalInstitutionRequestingCasesViewManagementList from "@/pages/administratorMedicalInstitutionRequestingCasesViewManagementList/index.vue";
import DetailsOfApplicantsForCasesInEducationalInstitutions from "@/pages/detailsOfApplicantsForCasesInEducationalInstitutions/index.vue";
import DetailsOfCaseProgressInMedicalInstitutions from "@/pages/detailsOfCaseProgressInMedicalInstitutions/index.vue";
import MedicalInstitutionNewsView from "@/pages/medicalInstitutionNewsView/index.vue";
import EducationInstitutionNewsView from "@/pages/educationInstitutionNewsView/index.vue";
import AdministratorsViewMedicalList from "@/pages/administratorsViewMedicalList/index.vue";
import AdministratorsViewMedicalInstitutionsClickDetails from "@/pages/administratorsViewMedicalInstitutionsClickDetails/index.vue";
import AdministratorsMedicalListStaffManagement from "@/pages/administratorsMedicalStaffManagement/index.vue";
import AdministratorsOnlyMedicalListStaffManagement from "@/pages/administratorsOnlyMedicalStaffManagement/index.vue";
import TransitBearer from "@/pages/transitBearer/index.vue";
import AdministratorSystemAdministrator from "@/pages/administratorSystemAdministrator/index.vue";
import AdministratorApplicationReviea from "@/pages/administratorApplicationReviea/index.vue";
import AdministratorDataDictionary from "@/pages/administratorDataDictionary/index.vue";
import AdminAddEducationalInstitutionInformation from "@/pages/adminAddEducationalInstitutionInformation/index.vue";
import EducationalInstitutionTalentRevisionProgress1 from "@/pages/educationalInstitutionTalentRevisionProgress1/index.vue";
import EducationalInstitutionTalentRevisionProgress2 from "@/pages/educationalInstitutionTalentRevisionProgress2/index.vue";
import AdminPostAddPageProgressOne from "@/pages/adminPostAddPageProgressOne/index.vue";
import AdminPostAddPageProgressTwo from "@/pages/adminPostAddPageProgressTwo/index.vue";
import AdminAddMedicalInstitutionInformation from "@/pages/adminAddMedicalInstitutionInformation/index.vue";
import AdminFrontpage from "@/pages/adminDataPanel/index.vue";
import ForgetPasswordEmailLink from "@/pages/forgetPasswordEmailLink/index.vue";
import LoginAdmin from "@/pages/loginAdmin/index.vue";
import AdminRegister from "@/pages/adminRegister/index.vue";
import MedicalRegister from "@/pages/medicalRegister/index.vue";
import AdministratorAddsMedicalInformation from "@/pages/administratorAddsMedicalInformation/index.vue";
import AdministratorsViewEducationInstitutionsClickDetails from "@/pages/administratorsViewEducationInstitutionsClickDetails/index.vue";
import AdministratorsEducationStaffManagement from "@/pages/administratorsEducationStaffManagement/index.vue";
import AdministratorsOnlyEducationStaffManagement from "@/pages/administratorsOnlyEducationStaffManagement/index.vue";
import UserInformationListOfMedicalInstitutionsSeekingApplicants from "@/pages/userInformationListOfMedicalInstitutionsSeekingApplicants";
import DecryptBackendReturnValue from "@/pages/decryptBackendReturnValue/index.vue";
import MedicalAdminInstitutionJobCreation1 from "@/pages/medicalAdminInstitutionJobCreation1/index.vue";
import MedicalAdminInstitutionJobCreation2 from "@/pages/medicalAdminInstitutionJobCreation2/index.vue";
import MedicalAdminInstitutionJobCreation3 from "@/pages/medicalAdminInstitutionJobCreation3/index.vue";
import MedicalInstitutionsCollectApplicationInformationList from "@/pages/medicalInstitutionsCollectApplicationInformationList/index.vue";
import EducationalInstitutionsCollectApplicationInformationList from "@/pages/educationalInstitutionsCollectApplicationInformationList/index.vue";
import UserEducationInstitutionsToModifyTheSchedule1 from "@/pages/userEducationInstitutionsToModifyTheSchedule1/index.vue";
import UserEducationInstitutionsToModifyTheSchedule2 from "@/pages/userEducationInstitutionsToModifyTheSchedule2/index.vue";
import UserEducationInstitutionsToModifyTheSchedule3 from "@/pages/userEducationInstitutionsToModifyTheSchedule3/index.vue";
import UserEducationalInstitutionTalentListView from "@/pages/userEducationalInstitutionTalentListView/index.vue";

import EducationAdminTalentAdd1 from "@/pages/educationAdminTalentAdd1/index.vue";
import EducationAdminTalentAdd2 from "@/pages/educationAdminTalentAdd2/index.vue";
import EducationAdminTalentAdd3 from "@/pages/educationAdminTalentAdd3/index.vue";
import medicalInstitutionJobRevise1 from "@/pages/medicalInstitutionJobRevise1/index.vue";
import medicalInstitutionJobRevise2 from "@/pages/medicalInstitutionJobRevise2/index.vue";
import medicalInstitutionJobRevise3 from "@/pages/medicalInstitutionJobRevise3/index.vue";
import adminEmployeeInformationModification from "@/pages/adminEmployeeInformationModification/index.vue";
import adminPostAddPageProgressThree from "@/pages/adminPostAddPageProgressThree/index.vue";
import adminTalentAdd1 from "@/pages/adminTalentAdd1/index.vue";
import adminTalentAdd2 from "@/pages/adminTalentAdd2/index.vue";
import adminTalentAdd3 from "@/pages/adminTalentAdd3/index.vue";
import adminJobRevise1 from "@/pages/adminJobRevise1/index.vue";
import adminJobRevise2 from "@/pages/adminJobRevise2/index.vue";
import adminJobRevise3 from "@/pages/adminJobRevise3/index.vue";
import medicalInstitutionCollectionTalentsViewList from "@/pages/medicalInstitutionCollectionTalentsViewList/index.vue";
import adminCollectionManagement from "@/pages/adminCollectionManagement/index.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "frontPage",
      component: FrontPage,
      meta: {
        isShow: false
      }
    },
    {
      path: "/medicalIndex",
      name: "Medical",
      component: Medical,
      meta: {
        isShow: false
      }
    },
    {
      path: "/educateIndex",
      name: "educateFront",
      component: EducateFront,
      meta: {
        isShow: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        isShow: false
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        isShow: false
      }
    },
    {
      path: "/advancedCertification",
      name: "advancedCertification",
      component: AdvancedCertification,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitution",
      name: "medicalInstitution",
      component: MedicalInstitution,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionInformation",
      name: "medicalInstitutionInformation",
      component: MedicalInstitutionInformation,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalCertificationAdd",
      name: "educationalCertificationAdd",
      component: EducationalCertificationAdd,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalCertificationTable",
      name: "educationalCertificationTable",
      component: EducationalCertificationTable,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalCertificationRevise",
      name: "educationalCertificationRevise",
      component: EducationalCertificationRevise,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionInformation",
      name: "educationalInstitutionInformation",
      component: EducationalInstitutionInformation,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalCertificationModification",
      name: "medicalCertificationModification",
      component: MedicalCertificationModification,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationViewMedicalHomepage",
      name: "educationViewMedicalHomepage",
      component: EducationViewMedicalHomepage,
      meta: {
        isShow: true
      }
    },
    {
      path: "/allPagesName",
      name: "allPagesName",
      component: AllPagesName,
      meta: {
        isShow: false
      }
    },
    {
      path: "/medicalStaffManagement",
      name: "medicalStaffManagement",
      component: MedicalStaffManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/auditFailure",
      name: "auditFailure",
      component: AuditFailure,
      meta: {
        isShow: true
      }
    },
    {
      path: "/userFailure",
      name: "userFailure",
      component: UserFailure,
      meta: {
        isShow: true
      }
    },
    {
      path: "/reviewSucceeded",
      name: "reviewSucceeded",
      component: ReviewSucceeded,
      meta: {
        isShow: true
      }
    },
    {
      path: "/underReview",
      name: "underReview",
      component: UnderReview,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalViewEducationHomepage",
      name: "medicalViewEducationHomepage",
      component: MedicalViewEducationHomepage,
      meta: {
        isShow: true
      }
    },
    {
      path: "/employeeApplicationFailed",
      name: "employeeApplicationFailed",
      component: EmployeeApplicationFailed,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationAdminTalentAddOne",
      name: "educationAdminTalentAdd1",
      component: EducationAdminTalentAdd1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationAdminTalentAddTwo",
      name: "educationAdminTalentAdd2",
      component: EducationAdminTalentAdd2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationAdminTalentAddThree",
      name: "educationAdminTalentAdd3",
      component: EducationAdminTalentAdd3,
      meta: {
        isShow: true
      }
    },

    {
      path: "/educationViewJobInformation",
      name: "educationViewJobInformation",
      component: EducationViewJobInformation,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInformationReply",
      name: "educationalInformationReply",
      component: EducationalInformationReply,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInformationReply",
      name: "medicalInformationReply",
      component: MedicalInformationReply,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalJobInformationReply",
      name: "medicalJobInformationReply",
      component: MedicalJobInformationReply,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionJobCreationOne",
      name: "medicalInstitutionJobCreation",
      component: MedicalInstitutionJobCreation1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationStaffManagement",
      name: "educationStaffManagement",
      component: EducationStaffManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationAuditFailure",
      name: "educationAuditFailure",
      component: EducationAuditFailure,
      meta: {
        isShow: true
      }
    },
    {
      path: "/userApplying",
      name: "userApplying",
      component: UserApplying,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationReviewSucceeded",
      name: "educationReviewSucceeded",
      component: EducationReviewSucceeded,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationUnderReview",
      name: "educationUnderReview",
      component: EducationUnderReview,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationTalentAddOne",
      name: "educationTalentAdd1",
      component: EducationTalentAdd1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionJobCreationTwo",
      name: "medicalInstitutionJobCreation2",
      component: MedicalInstitutionJobCreation2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionJobCreationThree",
      name: "medicalInstitutionJobCreation3",
      component: MedicalInstitutionJobCreation3,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationTalentAddTwo",
      name: "educationTalentAdd2",
      component: EducationTalentAdd2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionAddRecruiter",
      name: "educationalInstitutionAddRecruiter",
      component: EducationalInstitutionAddRecruiter,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalViewAllCandidates",
      name: "medicalViewAllCandidates",
      component: MedicalViewAllCandidates,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalViewAllCases",
      name: "educationalViewAllCases",
      component: EducationalViewAllCases,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionCaseRecruitmentList",
      name: "medicalInstitutionCaseRecruitmentList",
      component: MedicalInstitutionCaseRecruitmentList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionCaseCollectionList",
      name: "educationalInstitutionCaseCollectionList",
      component: EducationalInstitutionCaseCollectionList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalFavouritesEducationalInstitutionsViewList",
      name: "medicalFavouritesEducationalInstitutionsViewList",
      component: MedicalFavouritesEducationalInstitutionsViewList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationInstitutionCaseResponderViewing",
      name: "educationInstitutionCaseResponderViewing",
      component: EducationInstitutionCaseResponderViewing,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionsTalentApplicationList",
      name: "educationalInstitutionsTalentApplicationList",
      component: EducationalInstitutionsTalentApplicationList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorInformationManagement",
      name: "administratorInformationManagement",
      component: AdministratorInformationManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminStaffManagement",
      name: "adminStaffManagement",
      component: AdminStaffManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorCaseManagement",
      name: "administratorCaseManagement",
      component: AdministratorCaseManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorApplicationManagement",
      name: "administratorApplicationManagement",
      component: AdministratorApplicationManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorApplicationManagementOnlyCase",
      name: "administratorApplicationManagementOnlyCase",
      component: AdministratorApplicationManagementOnlyCase,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorApplicationManagementOnlyEducation",
      name: "administratorApplicationManagementOnlyEducation",
      component: AdministratorApplicationManagementOnlyEducation,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminTalentManagement",
      name: "adminTalentManagement",
      component: AdminTalentManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorViewEducationalList",
      name: "administratorViewEducationalList",
      component: AdministratorViewEducationalList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionTalentInformationViewPublic",
      name: "medicalInstitutionTalentInformationViewPublic",
      component: MedicalInstitutionTalentInformationViewPublic,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionCaseManagementDetails",
      name: "medicalInstitutionCaseManagementDetails",
      component: MedicalInstitutionCaseManagementDetails,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionTalentRevisionProgress3",
      name: "educationalInstitutionTalentRevisionProgress3",
      component: EducationalInstitutionTalentRevisionProgress3,
      meta: {
        isShow: true
      }
    },
    {
      path: "/EducationalInstitutionCollectionMedicalInstitutionList",
      name: "educationalInstitutionCollectionMedicalInstitutionList",
      component: EducationalInstitutionCollectionMedicalInstitutionList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionTalentListView",
      name: "educationalInstitutionTalentListView",
      component: EducationalInstitutionTalentListView,
      meta: {
        isShow: true
      }
    },

    {
      path: "/administratorMedicalInstitutionRequestingCasesViewManagementList",
      name: "administratorMedicalInstitutionRequestingCasesViewManagementList",
      component: AdministratorMedicalInstitutionRequestingCasesViewManagementList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/detailsOfApplicantsForCasesInEducationalInstitutions",
      name: "detailsOfApplicantsForCasesInEducationalInstitutions",
      component: DetailsOfApplicantsForCasesInEducationalInstitutions,
      meta: {
        isShow: true
      }
    },
    {
      path: "/detailsOfCaseProgressInMedicalInstitutions",
      name: "detailsOfCaseProgressInMedicalInstitutions",
      component: DetailsOfCaseProgressInMedicalInstitutions,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionNewsView",
      name: "medicalInstitutionNewsView",
      component: MedicalInstitutionNewsView,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorsViewMedicalList",
      name: "administratorsViewMedicalList",
      component: AdministratorsViewMedicalList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorsViewMedicalInstitutionsClickDetails",
      name: "administratorsViewMedicalInstitutionsClickDetails",
      component: AdministratorsViewMedicalInstitutionsClickDetails,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorsMedicalListStaffManagement",
      name: "administratorsMedicalListStaffManagement",
      component: AdministratorsMedicalListStaffManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationInstitutionNewsView",
      name: "educationInstitutionNewsView",
      component: EducationInstitutionNewsView,
      meta: {
        isShow: true
      }
    },
    {
      path: "/transitBearer",
      name: "transitBearer",
      component: TransitBearer,
      meta: {
        isShow: false
      }
    },
    {
      path: "/administratorSystemAdministrator",
      name: "administratorSystemAdministrator",
      component: AdministratorSystemAdministrator,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorApplicationReviea",
      name: "administratorApplicationReviea",
      component: AdministratorApplicationReviea,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorDataDictionary",
      name: "administratorDataDictionary",
      component: AdministratorDataDictionary,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminAddEducationalInstitutionInformation",
      name: "adminAddEducationalInstitutionInformation",
      component: AdminAddEducationalInstitutionInformation,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionTalentRevisionProgress1",
      name: "educationalInstitutionTalentRevisionProgress1",
      component: EducationalInstitutionTalentRevisionProgress1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionTalentRevisionProgress2",
      name: "educationalInstitutionTalentRevisionProgress2",
      component: EducationalInstitutionTalentRevisionProgress2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminPostAddPageProgressOne",
      name: "adminPostAddPageProgressOne",
      component: AdminPostAddPageProgressOne,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminPostAddPageProgressTwo",
      name: "adminPostAddPageProgressTwo",
      component: AdminPostAddPageProgressTwo,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminAddMedicalInstitutionInformation",
      name: "adminAddMedicalInstitutionInformation",
      component: AdminAddMedicalInstitutionInformation,
      meta: {
        isShow: true
      }
    },
    {
      path: "/forgetPasswordEmailLink",
      name: "forgetPasswordEmailLink",
      component: ForgetPasswordEmailLink,
      meta: {
        isShow: false
      }
    },
    {
      path: "/adminFrontPage",
      name: "adminFrontpage",
      component: AdminFrontpage,
      meta: {
        isShow: true
      }
    },
    {
      path: "/loginAdmin",
      name: "loginAdmin",
      component: LoginAdmin,
      meta: {
        isShow: false
      }
    },
    {
      path: "/adminRegister",
      name: "adminRegister",
      component: AdminRegister,
      meta: {
        isShow: false
      }
    },
    {
      path: "/medicalRegister",
      name: "medicalRegister",
      component: MedicalRegister,
      meta: {
        isShow: false
      }
    },
    {
      path: "/administratorAddsMedicalInformation",
      name: "administratorAddsMedicalInformation",
      component: AdministratorAddsMedicalInformation,
      meta: {
        isShow: true
      }
    },
    {
      path: "/userInformationListOfMedicalInstitutionsSeekingApplicants",
      name: "userInformationListOfMedicalInstitutionsSeekingApplicants",
      component: UserInformationListOfMedicalInstitutionsSeekingApplicants,
      meta: {
        isShow: true
      }
    },

    {
      path: "/administratorsViewEducationInstitutionsClickDetails",
      name: "administratorsViewEducationInstitutionsClickDetails",
      component: AdministratorsViewEducationInstitutionsClickDetails,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorsOnlyMedicalListStaffManagement",
      name: "administratorsOnlyMedicalListStaffManagement",
      component: AdministratorsOnlyMedicalListStaffManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorsEducationStaffManagement",
      name: "administratorsEducationStaffManagement",
      component: AdministratorsEducationStaffManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/administratorsOnlyEducationStaffManagement",
      name: "administratorsOnlyEducationStaffManagement",
      component: AdministratorsOnlyEducationStaffManagement,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalAdminInstitutionJobCreation1",
      name: "medicalAdminInstitutionJobCreation1",
      component: MedicalAdminInstitutionJobCreation1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalAdminInstitutionJobCreation2",
      name: "medicalAdminInstitutionJobCreation2",
      component: MedicalAdminInstitutionJobCreation2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalAdminInstitutionJobCreation3",
      name: "medicalAdminInstitutionJobCreation3",
      component: MedicalAdminInstitutionJobCreation3,
      meta: {
        isShow: true
      }
    },
    {
      path: "/decryptBackendReturnValue",
      name: "decryptBackendReturnValue",
      component: DecryptBackendReturnValue,
      meta: {
        isShow: false
      }
    },
    {
      path: "/medicalInstitutionsCollectApplicationInformationList",
      name: "medicalInstitutionsCollectApplicationInformationList",
      component: MedicalInstitutionsCollectApplicationInformationList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/userEducationInstitutionsToModifyTheSchedule1",
      name: "userEducationInstitutionsToModifyTheSchedule1",
      component: UserEducationInstitutionsToModifyTheSchedule1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/userEducationInstitutionsToModifyTheSchedule2",
      name: "userEducationInstitutionsToModifyTheSchedule2",
      component: UserEducationInstitutionsToModifyTheSchedule2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/userEducationInstitutionsToModifyTheSchedule3",
      name: "userEducationInstitutionsToModifyTheSchedule3",
      component: UserEducationInstitutionsToModifyTheSchedule3,
      meta: {
        isShow: true
      }
    },
    {
      path: "/userEducationalInstitutionTalentListView",
      name: "userEducationalInstitutionTalentListView",
      component: UserEducationalInstitutionTalentListView,
      meta: {
        isShow: true
      }
    },
    {
      path: "/educationalInstitutionsCollectApplicationInformationList",
      name: "educationalInstitutionsCollectApplicationInformationList",
      component: EducationalInstitutionsCollectApplicationInformationList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionJobReviseOne",
      name: "medicalInstitutionJobRevise1",
      component: medicalInstitutionJobRevise1,
      meta: {
        isShow: true,
        keepAlive: true
      }
    },
    {
      path: "/medicalInstitutionJobReviseTwo",
      name: "medicalInstitutionJobRevise2",
      component: medicalInstitutionJobRevise2,
      meta: {
        isShow: true,
        keepAlive: true
      }
    },
    {
      path: "/medicalInstitutionJobReviseThree",
      name: "medicalInstitutionJobRevise3",
      component: medicalInstitutionJobRevise3,
      meta: {
        isShow: true,
        keepAlive: true
      }
    },

    {
      path: "/educationTalentAddThree",
      name: "educationTalentAdd3",
      component: EducationTalentAdd3,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminEmployeeInformationModification",
      name: "adminEmployeeInformationModification",
      component: adminEmployeeInformationModification,
      meta: {
        isShow: false
      }
    },
    {
      path: "/adminPostAddPageProgressThree",
      name: "adminPostAddPageProgressThree",
      component: adminPostAddPageProgressThree,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminTalentAdd1",
      name: "adminTalentAdd1",
      component: adminTalentAdd1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminTalentAdd2",
      name: "adminTalentAdd2",
      component: adminTalentAdd2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminTalentAdd3",
      name: "adminTalentAdd3",
      component: adminTalentAdd3,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminJobRevise1",
      name: "adminJobRevise1",
      component: adminJobRevise1,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminJobRevise2",
      name: "adminJobRevise2",
      component: adminJobRevise2,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminJobRevise3",
      name: "adminJobRevise3",
      component: adminJobRevise3,
      meta: {
        isShow: true
      }
    },
    {
      path: "/medicalInstitutionCollectionTalentsViewList",
      name: "medicalInstitutionCollectionTalentsViewList",
      component: medicalInstitutionCollectionTalentsViewList,
      meta: {
        isShow: true
      }
    },
    {
      path: "/adminCollectionManagement",
      name: "adminCollectionManagement",
      component: adminCollectionManagement,
      meta: {
        isShow: true
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js